import BaseAPI from "@/api/BaseAPI";

export class UserAPI extends BaseAPI {
  constructor() {
    super('');
  }

  /**
   * @param {'founder'| 'region'} typeContact
   * @param {Number} id
   * */
  getBlockInfo(typeContact, id) {
    return this.http.get('/stageData/getBlock', {data: {[typeContact + 'Id']: id}})
  }

  /**
   * @param {Number} id
   * */
  getBlockOrganizationInfo(id) {
    return this.http.get('/block', {data: {['orgId']: id}})
  }

  /**
   * @param {'founder'| 'region'} typeContact
   * @param {Number} id
   * */
  getBlockAllowInfo(typeContact, id) {
    return this.http.get('/stageData/canStageBlock', {data: {[typeContact + 'Id']: id}})
  }

  /**
   * @param {'founder'| 'region'} typeContact
   * @param {1 | 2 | 3} stageId
   * @param {Number} id
   * */
  setBlock(typeContact, stageId = 1, id) {
    return this.http.put(`/stageData/blockStage${stageId}?${typeContact + 'Id'}=${id}`, {})
  }

  /**
   * @param {'ORG_BLOCK' | 'KONVERT_BLOCK'} type
   * @param {boolean} value
   * @param {Number} id
   * */
  setBlockOrg(type, value = true, id) {
    return this.http.post(`/block?flag=${value}&type=${type}&orgId=${id}`, {})
  }

  checkForBlockOrg(id) {
    return this.http.get(`/block/check?orgId=${id}`)
  }

  /**
   * @param {'founder'| 'region'} typeContact
   * @param {1 | 2 | 3} stageId
   * @param {Number} id
   * */
  unBlock(typeContact, stageId = 1, id) {
    return this.http.put(`/stageData/unblock?stage=${stageId}&${typeContact + 'Id'}=${id}`, {})
  }

  /**
   * @param {boolean} flag
   * @param {1 | 2 | 3 | 4 | 5} form
   * @param {Number} orgId
   * */
  setCheckForm(orgId, form, flag) {
    return this.http.post(`/block/acceptForm?flag=${flag}&formId=${form}&orgId=${orgId}`, {})
  }
}

export default new UserAPI();